import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import Panel from '../Panel'

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function Accordion({ className, panels }) {
  const [activeTab, setActiveTab] = useState(null)

  const handleClick = (index) => {
    if (index === activeTab) {
      setActiveTab(null)
    } else {
      setActiveTab(index)
    }
  }

  return (
    <div className={classnames('accordion', className)}>
      {panels.map((panel, index) => <Panel key={`panel-${index}`} handleClick={handleClick} index={index} isActive={activeTab === index} {...panel} />)}
      <style jsx>{styles}</style>
    </div>
  )
}

Accordion.propTypes = {
  className: PropTypes.string,
  panels: PropTypes.arrayOf(PropTypes.shape(Panel.propTypes))
}

Accordion.defaultProps = {
  className: null,
  panels: {}
}

Accordion = chainDecorators(decorators, Accordion)

export default Accordion
